import { render, staticRenderFns } from "./IncidenceList.vue?vue&type=template&id=d6906b32"
import script from "./IncidenceList.vue?vue&type=script&lang=js"
export * from "./IncidenceList.vue?vue&type=script&lang=js"
import style0 from "./IncidenceList.vue?vue&type=style&index=0&id=d6906b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports